import { ToastProvider } from 'react-toast-notifications';
import React, { Fragment, useEffect, useRef } from 'react';
import { FormGroup, Row } from 'react-bootstrap';
import language from '../../config/es';
import { Radio, RadioGroup } from 'react-radio-group';
import Select from 'react-select';
import {
  findTypeByConcept,
  findAllConcepts,
  createType,
  deleteType,
  updateType,
  createConcept,
} from '../../redux/type.duck';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../redux/store/hooks';

import { es_vacio } from '../../config/validate';
//Session user
import SessionConfig from '../../config/session_config';
//Crud compartido
import {
  useCrudState,
  useCrudLifecycle,
} from '../../components/Crud/crudHooks';
import {
  buildEditColumn,
  createFormState,
  renderDeleteAction,
  toIdList,
  requireValues,
} from '../../components/Crud/crudHelpers';
import {
  RequiredFieldsAlert,
  TextField,
} from '../../components/Crud/CrudFields';
import {
  CrudButtons,
  CrudDataTable,
  CrudPage,
} from '../../components/Crud/CrudLayout';

const TypeConcept = () => {
  const ref = useRef()
  const dispatch = useAppDispatch();
  const {
    data,
    refreshState,
    updateState,
    viewNotification,
    handleSelectRow,
    initStateDelete,
    finishDelete,
  } = useCrudState({
    ...createFormState(),
    id: 0,
    types: [],
    responseCreate: [],
    responseEdit: [],
    concept: { value: '', error: '' },
    conceptData: { value: '', error: '' },
    name: { value: '', error: '' },
    code: { value: '', error: '' },
    value: { value: '', error: '' },
    username: 'admin',
    disableUpdate: false,
    auth: JSON.parse(sessionStorage.getItem('user')),
    error: '',
  });
  data.types = useSelector((store) => store.typeReducer.types);
  data.error = useSelector((store) => store.typeReducer.errorType);
  //ciclo de vida ---------------------------------------------------
  useEffect(() => {
    messageError();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.error]);
  useCrudLifecycle(ref, data, () => {
    initTable();
    void loadConcepts();
  });
  const messageError = () => {
    if (data.error !== '') {
      viewNotification(data.error.error, 'error');
    }
  };
  const loadRolData = async () => {
    updateState(true, 'pendingData');
    await dispatch(
      findTypeByConcept(data.auth.id.user.username, data.concept.value)
    );
    data.pendingData = false;
    refreshState();
  };
  const initTable = () => {
    data.columns = [
      {
        name: language.messages.type.name,
        sortable: false,
        wrap: true,
        width: '45%',
        cell: (row) => <div className="small text-uppercase">{row.name}</div>,
      },
      {
        name: language.messages.type.code,
        sortable: false,
        wrap: true,
        width: '20%',
        aling: 'left',
        cell: (row) => (
          <div className="text-primary small text-uppercase">{row.code}</div>
        ),
      },
      {
        name: language.messages.type.value,
        sortable: false,
        wrap: true,
        width: '15%',
        cell: (row) => (
          <div className="text-muted small text-uppercase">{row.value}</div>
        ),
      },
      buildEditColumn(handleButtonEdit, { width: '10px', idKey: 'Id' }),
    ];
    updateState(data.columns, 'columns');
  };

  const loadConcepts = async () => {
    data.transactionsNotAssigned = await dispatch(findAllConcepts());
    data.tranNotAssigned = { value: 0, label: '' };
    refreshState();
  };

  const handleButtonEdit = (row) => {
    clearError();
    data.editTransaction = false;
    data.addTransaction = true;
    data.editType = false;
    data.id = row.id;
    data.tranNotAssigned.value = row.concept.id;
    data.tranNotAssigned.label = row.concept.name;
    data.concept.value = row.concept.id;
    data.name.value = row.name;
    data.code.value = row.code;
    data.value.value =
      row.value === undefined || row.value === null ? '' : row.value;
    data.disableUpdate = true;
    refreshState();
  };

  const handleOnChange = (e) => {
    data.concept = { value: '', label: '' };
    if (e === 'Crear') {
      data.editTransaction = true;
      data.addTransaction = false;
    } else {
      data.editTransaction = false;
      data.addTransaction = true;
    }
    data.types = [];
    data.tranNotAssigned = { value: 0, label: '' };
    updateState(false, 'pendingData');
    handleSelectChange(data.tranNotAssigned);
  };

  const handleSelectChange = (value) => {
    data.tranNotAssigned = value;
    data.concept.value = data.tranNotAssigned.value;
    data.concept.error = '';
    void loadRolData();
  };

  const saveData = () => {
    if (data.editTransaction) {
      void saveConcept();
    } else {
      void saveDatatype();
    }
  };
  const saveConcept = async () => {
    //conceptData
    validateConcept();
    if (data.errors.length === 0) {
      data.enable = false;
      refreshState();
      let json = {
        name: data.conceptData.value,
        status: 1,
        userAdmin: data.username,
      };
      let response = await dispatch(
        createConcept(json, data.auth.id.user.username)
      );
      if (response.error === undefined) {
        updateState(true, 'pendingData');
        await loadConcepts();
        viewNotification(
          language.messages.msmRegister.replace('{0}', data.conceptData.value),
          'success'
        );
        clear();
      }
      data.pendingData = false;
      data.enable = true;
    } else {
      viewNotification(language.messages.msmErrorForm, 'error');
    }
    refreshState();
  };
  const saveDatatype = async () => {
    validate();
    if (data.errors.length === 0) {
      data.pendingData = true;
      data.enable = false;
      refreshState();

      let json = {
        id: data.id === 0 ? null : data.id,
        concept: { id: data.concept.value },
        name: data.name.value,
        code: data.code.value,
        value: data.value.value,
        status: 1,
        userAdmin: data.username,
      };
      let response = '';

      if (data.id === 0) {
        response = await dispatch(createType(json, data.auth.id.user.username));
      } else {
        response = await dispatch(updateType(json, data.auth.id.user.username));
      }
      if (response.error === undefined) {
        updateState(true, 'pendingData');
        await reloadData();

        viewNotification(
          language.messages.msmRegister.replace('{0}', data.name.value),
          'success'
        );
        clear();
      }

      data.pendingData = false;
      data.enable = true;
    } else {
      viewNotification(language.messages.msmErrorForm, 'error');
    }
    refreshState();
  };
  const validateConcept = () => {
    data.errors = [];
    data.conceptData.error = '';
    requireValues(data, ['conceptData']);
    refreshState();
  };
  const validate = () => {
    clearError();
    requireValues(data, ['name', 'code']);

    if (es_vacio(data.concept.value) || data.concept.value === 0) {
      data.errors.push('concept.error');
      data.concept.error = language.messages.warning_required_field;
    }

    refreshState();
  };
  const reloadData = async () => {
    data.pendingData = true;
    refreshState();
    await loadRolData();
  };

  const clear = () => {
    data.editType = true;
    data.id = 0;
    data.name = { value: '', label: '' };
    data.code = { value: '', label: '' };
    data.value = { value: '', label: '' };
    data.conceptData = { value: '', error: '' };
    data.disableUpdate = false;
    refreshState();
  };

  const clearError = () => {
    data.errors = [];
    data.name.error = '';
    data.code.error = '';
    data.concept.error = '';
    data.conceptData.error = '';
  };
  const onChange = (event) => {
    switch (event.target.name) {
      case 'concept':
        data.conceptData.value = event.target.value;
        data.conceptData.error = '';
        break;
      case 'name':
        data.name.value = event.target.value;
        data.name.error = '';
        break;
      case 'code':
        data.code.value = event.target.value;
        data.code.error = '';
        break;
      case 'value':
        data.value.value = event.target.value;
        data.value.error = '';
        break;
      default:
        break;
    }
    refreshState();
  };

  const handleDelete = () => {
    void disableData();
  };
  const disableData = async () => {
    if (data.selectedRows.length > 0) {
      let lsDelete = toIdList(data.selectedRows);
      initStateDelete(false);

      let response = await dispatch(
        deleteType(lsDelete, data.auth.id.user.username)
      );
      finishDelete(response.code === undefined, response.message, reloadData);
    }
  };

  const contextActions = renderDeleteAction(
    handleDelete,
    data.enable,
    'Dar de Baja'
  );

  return (
    <Fragment>
    <SessionConfig ref={ref}/>
      <br />
      <CrudPage
        formCol={{ md: 5, xl: 4 }}
        formTitle={language.messages.type.title}
        form={
          <form autoComplete="off">
            <RequiredFieldsAlert textClassName="small " />
            {data.editType && (
              <FormGroup>
                <RadioGroup
                  name="fruits"
                  className="small "
                  onChange={(e) => handleOnChange(e)}
                >
                  <div className="radio-button-background">
                    <Radio value="Crear" className="radio-button ml-1" />{' '}
                    {language.messages.type.createConcept}
                  </div>
                  <div className="radio-button-background">
                    <Radio
                      value="Seleccionar"
                      className="radio-button ml-1"
                      checked={!data.editTransaction}
                    />{' '}
                    {language.messages.type.selectConcept}
                  </div>
                </RadioGroup>
              </FormGroup>
            )}
            {data.editTransaction && (
              <TextField
                compact={false}
                className="small"
                label={language.messages.type.nameConcept}
                placeholder="Concepto"
                name="concept"
                field={data.conceptData}
                onChange={onChange}
              />
            )}
            {data.addTransaction && (
              <FormGroup>
                <Select classNamePrefix="ui-select"
                  className="text-uppercase small"
                  isDisabled={data.disableUpdate === true}
                  placeholder={language.messages.lblSingleSelect}
                  name="classType"
                  options={data.transactionsNotAssigned}
                  value={{
                    value: data.tranNotAssigned.value,
                    label: data.tranNotAssigned.label,
                  }}
                  onChange={(value) => {
                    handleSelectChange(value);
                  }}
                />
                <span className="small text-danger">
                  {data.concept.error}
                </span>
              </FormGroup>
            )}
            {data.addTransaction && (
              <TextField
                label={language.messages.labelTypeName}
                name="name"
                field={data.name}
                onChange={onChange}
              />
            )}
            {data.addTransaction && (
              <Row>
                <TextField
                  col={{ md: 6 }}
                  label={language.messages.labelCode}
                  name="code"
                  field={data.code}
                  onChange={onChange}
                />
                <TextField
                  col={{ md: 6 }}
                  label={language.messages.type.value}
                  required={false}
                  name="value"
                  field={data.value}
                  onChange={onChange}
                />
              </Row>
            )}
            <CrudButtons
              withLoading
              wrapped
              enable={data.enable}
              isNew={data.id === 0}
              onSave={saveData}
              onClear={clear}
              onReload={reloadData}
            />
          </form>
        }
        tableCol={{ md: 7, xl: 5 }}
        tableClassTitle=" text-uppercase text-capitalize"
        tableIcon="fa fa-list"
        tableTitle={language.messages.type.titleGrid}
        table={
          <CrudDataTable
            data={data}
            title={
              data.types.length > 0
                ? language.messages.type.concept +
                  ' ' +
                  data.tranNotAssigned.label
                : ''
            }
            noHeader={data.types.length === 0}
            rows={data.types}
            onSelect={handleSelectRow}
            pointerOnHover={true}
            actions={contextActions}
          />
        }
      />
    </Fragment>
  );
};
const App = () => (
  <ToastProvider>
    <TypeConcept />
  </ToastProvider>
);
export default App;
